import { render, staticRenderFns } from "./AgentCreateUpdate.vue?vue&type=template&id=1f196be6"
import script from "./AgentCreateUpdate.vue?vue&type=script&lang=js"
export * from "./AgentCreateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports